import { Component } from '@angular/core';

import { finalize } from 'rxjs/operators';

import { BreakpointService } from '@library/core/services';
import { AccountService } from '@library/modules/user';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
   selector: 'lib-account-select',
   templateUrl: './account-select.component.html',
   styleUrls: ['./account-select.component.scss']
})
export class AccountSelectComponent {

   loading = false;

   constructor(
      public account: AccountService,
      public breakpoints: BreakpointService,
   ) {}

   ngOnInit():void{}

   setActive( id: number ): void {
      // Prevent a second switch while one is already in progress (double change).
      if ( this.loading ) { return; }

      // Show the spinner immediately on click. This also hides the account
      // dropdown trigger ( see template ), so the user cannot fire another switch
      // before the request resolves.
      this.loading = true;

      this.account.switchAccount( id )
      .pipe(
         finalize( () => this.loading = false ),
         untilDestroyed(this),
      )
      .subscribe();
   }

   ngOnDestroy() {}
}
